<template>
  <v-dialog v-model="show">
    <v-card>
      <v-card-title>
        <h2>Billing History</h2>
        <v-spacer />
        <v-btn flat icon color="itoviGrayMid" @click="show = false"><v-icon>close</v-icon></v-btn>
      </v-card-title>

      <v-card-text class="pt-0 pl-3 pr-3">
        <v-layout align-center row wrap>
          <v-spacer style="width: 350px" />
          <v-select
              style="width: 150px"
              v-model="itemsPerPage"
              :items="itemsPerPageOptions"
              label="Items per page"
          />
        </v-layout>

        <div v-if="history === null || history.length === 0">
          No billing history
        </div>

        <template v-for="(item, index) in getCurrentPageItems()">

          <div :key="index" class="pt-4 pl-3 pr-3">
            <v-layout align-center row wrap>
              <span class="txt-bold">{{ item.date }}</span>
              <v-spacer />
            </v-layout>
            <template v-for="(lineItem, lineItemIndex) in item.line_items">

              <div :key="lineItemIndex" class="pl-2">
                <v-layout align-center row wrap>
                  <span>{{ lineItem.name }}</span>
                  <v-spacer />
                  <span>${{ formatPrice(lineItem.amount) }}</span>
                </v-layout>
              </div>
            </template>

            <div class="pl-2">
              <v-layout align-center row wrap>
                <span class="txt-bold">Total</span>
                <v-spacer />
                <span class="txt-bold">${{ formatPrice(item.total) }}</span>
              </v-layout>
            </div>
          </div>
        </template>

        <div class="text-xs-center pt-5 pb-4">
          <v-pagination
              v-model="page"
              :length="getHowManyPages()"
          />
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<style lang="scss" scoped>
  .txt-bold {
    font-weight: bold;
  }
</style>

<script>
  export default {
    data: ()=> ({
      itemsPerPage: 3,
      itemsPerPageOptions: [3, 5, 10, 20, 50, 100],
      page: 1
    }),
    props: {
      value: {
        type: Boolean,
        default: false
      },
      history:{
        type: Array,
        required: true,
        default: () => ([ ])
      }
    },
    watch: {
      /**
       *  we are watching this value b/c there are some cases where
       *  the itemsPerPage is changed and the current page is such
       *  that it ends up on a page with no items. which is confusing
       */
      itemsPerPage(newVal, oldVal) {
        if (newVal > oldVal) this.page = 1
        this.itemsPerPage = newVal
      }
    },
    methods: {
      getHowManyPages() {
        return Math.ceil(this.history.length / this.itemsPerPage)
      },
      getCurrentPageItems() {
        if ( this.history.length < this.itemsPerPage) return this.history

        let start = ((this.page - 1) * this.itemsPerPage)
        let end = this.page * this.itemsPerPage;
        if (end > this.history.length) end = this.history.length

        return this.history.slice(start, end)
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2)
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      }
    },
    computed: {
      show: {
        get () {
          return this.value
        },
        set (value) {
          this.$emit('input', value)
        }
      }
    }
  }
</script>
